module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAkCAYAAABFaiBLAAAAAXNSR0IArs4c6QAAACBJREFUOE9jvC0o9p8BB2AclWRgGA0EhtFAAGeQkZISAMt2SEmuvrA9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner1/h2-2.png
// module id = XqMC
// module chunks = 1